import { Box, CardMedia, Divider } from '@material-ui/core';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import usePublic, { usePublicFn } from '../../../../utilities/usePublic';
import useBasicStyles from '../../useBasicStyles';
import SidePanelMenu from './SidePanelMenu';

export type PanelListItem = {
    icon: string;
    text: string;
    to: string;
    groupLabel?: string;
};

export type SidePanelMenuProps = {
    items: PanelListItem[];
};

export type DrawerHeaderProps = {
    open: boolean;
};

const DrawerHeader = ({ open }: DrawerHeaderProps) => {
    const { t } = useTranslation(['homePage']);

    const classes = useBasicStyles();

    const eurokarsPreOwned = usePublic('assets/images/eurokarsPreOwned.svg');
    const logo = usePublic('assets/images/logo.svg');

    const publicFn = usePublicFn();

    const items: PanelListItem[] = useMemo(
        () => [
            { icon: publicFn('assets/menuIcons/dashboard-24px.svg'), text: t('homePage:menuBar.dashboard'), to: '/' },
            {
                icon: publicFn('assets/menuIcons/account_circle-24px.svg'),
                text: t('homePage:menuBar.userDatabase'),
                to: '/users',
            },
            {
                icon: publicFn('assets/menuIcons/gpp_good-24px.svg'),
                text: t('homePage:menuBar.approvals'),
                to: '/approvals',
            },
            {
                icon: publicFn('assets/menuIcons/Group_6028.svg'),
                text: t('homePage:menuBar.purchaseTransactionRecords'),
                to: '/purchaseTransactions',
            },
            {
                icon: publicFn('assets/menuIcons/Group_6029.svg'),
                text: t('homePage:menuBar.salesTransactionRecords'),
                to: '/salesTransactions',
            },
            {
                icon: publicFn('assets/menuIcons/receipt_long-24px.svg'),
                text: t('homePage:menuBar.biddingSessions'),
                to: '/biddingSessions',
            },
            {
                icon: publicFn('assets/menuIcons/circle_notifications-24px.svg'),
                text: t('homePage:menuBar.notificationsLog'),
                to: '/notifications',
            },
            {
                icon: publicFn('assets/menuIcons/history.svg'),
                text: t('homePage:menuBar.activityHistory'),
                to: '/activityHistory',
            },
            {
                icon: publicFn('assets/menuIcons/tag.svg'),
                text: t('homePage:menuBar.tagManagement'),
                to: '/tags',
            },
        ],
        [t, publicFn]
    );

    return (
        <Box>
            <CardMedia className={classes.logo} image={open ? eurokarsPreOwned : logo} />
            <Divider className={classes.divider} />
            <SidePanelMenu items={items} />
        </Box>
    );
};

export default DrawerHeader;
